import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

const headers = { 'Content-Type': 'application/json' };
const base = `${API_BASE_URL}/Purchase`;

const handle = (err) => {
    if (err.response?.data) throw err.response.data;
    throw err;
};

// GET cost centers the current role can issue old stock to
export const getOldStockIssueCCs = async (UID, RID) => {
    try {
        const res = await axios.get(`${base}/Getoldstockissueccs`, { params: { UID, RID }, headers });
        return res.data;
    } catch (err) { handle(err); }
};

// GET indents available for old-stock issue under a cost center
export const getOldIssueIndentsByCC = async (CCCode) => {
    try {
        const res = await axios.get(`${base}/GetOldIssueIndentsbyCC`, { params: { CCCode }, headers });
        return res.data;
    } catch (err) { handle(err); }
};

// GET whether an indent is an "Asset" indent (drives the depreciation columns) or not
export const getIndentType = async (Indentno) => {
    try {
        const res = await axios.get(`${base}/GetIndentType`, { params: { Indentno }, headers });
        return res.data;
    } catch (err) { handle(err); }
};

// GET the max depreciation percent configured for a cost center pair, used to
// build the depreciation-percent dropdown options client-side
export const getItemDepPercentByCC = async (FromCC, ToCC) => {
    try {
        const res = await axios.get(`${base}/GetItemDepPercentbyCC`, { params: { FromCC, ToCC }, headers });
        return res.data;
    } catch (err) { handle(err); }
};

// GET the old-stock issue grid rows for a cost center + indent
export const getOldItemsIssueTempDetails = async (CCcode, Indent) => {
    try {
        const res = await axios.get(`${base}/GetOldItemsIssueTempDetails`, { params: { CCcode, Indent }, headers });
        return res.data;
    } catch (err) { handle(err); }
};

// POST — finalize and submit the old stock issue transaction
export const saveOldItemsIssue = async (payload) => {
    try {
        const res = await axios.post(`${base}/SaveOldItemsIssue`, payload, { headers, timeout: 30000 });
        return res.data;
    } catch (err) { handle(err); }
};
